import './WeekDaysHeader.css';
export default {
    "weekDaysHeader": "WeekDaysHeader_weekDaysHeader__530ac",
    "weekDay": "WeekDaysHeader_weekDay__530ac"
};
